export default "__VITE_PUBLIC_ASSET__14b76020__"